export const TRANSLATION_STATE = {
  RUNNING: 'RUNNING',
  READY: 'READY',
  FAILED: 'FAILED',
  SAVED: 'SAVED',
} as const;
export type TranslationState =
  (typeof TRANSLATION_STATE)[keyof typeof TRANSLATION_STATE];
export interface TranslationRow {
  cardId: string;
  code: string;
  namePt?: string;
  nameEn?: string;
  descriptionPt?: string;
  descriptionEn?: string;
  archetype?: string;
  translated: boolean;
  failed: boolean;
}
export interface TranslationJob {
  id: string;
  collectionId: string;
  state: TranslationState;
  total: number;
  completed: number;
  translated: number;
  translatedPercentage: number;
  missingPercentage: number;
  rows: TranslationRow[];
}
export interface TranslationJobInput {
  collectionId: string;
  jobId: string;
}
